module.exports = "https://qp-assets.quero.com/assets/images/landing/smartphone.png?a56dbe9f8e7f238413af2c5b3c23d49a";